<template>
  <div class="app-container">
    <el-container>
      <el-header>
        <div class="header-content">
          <div class="logo">
            <span>贷款产品管理系统</span>
          </div>
          <el-menu
            mode="horizontal"
            :router="true"
            :default-active="$route.path"
            class="main-menu"
          >
            <el-menu-item index="/products">
              <el-icon><Document /></el-icon>
              <span>产品管理</span>
            </el-menu-item>
            <el-menu-item index="/policies">
              <el-icon><Files /></el-icon>
              <span>政策管理</span>
            </el-menu-item>
            <el-menu-item index="/dicts">
              <el-icon><List /></el-icon>
              <span>字典管理</span>
            </el-menu-item>
          </el-menu>
        </div>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { List, Document, Files } from '@element-plus/icons-vue'
import { getAllDicts } from '@/utils/dictCache'

export default {
  name: 'App',
  components: {
    List,
    Document,
    Files
  },
  async created() {
    try {
      // 预加载所有字典数据
      await getAllDicts()
    } catch (error) {
      console.error('预加载字典数据失败:', error)
    }
  }
}
</script>

<style>
.el-container {
  height: 100vh;
}

.el-header {
  padding: 0;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.header-content {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 20px;
}

.logo {
  margin-right: 40px;
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.main-menu {
  flex: 1;
  border-bottom: none;
}

.el-main {
  padding: 20px;
  background-color: #f0f2f5;
}
</style> 